import * as z from 'zod';

const client = z.object({
  APP_ENV: z.enum(['development', 'staging', 'production', 'app']),
  API_URL: z.string(),
  APP_VERSION: z.string(),
  APP_BASE_URL: z.string(),
  APP_HOST_URL: z.string().optional(),
  API_HOLIDAYS: z.string(),
  API_MOCK: z.string(),
});

/**
 * @type {Record<keyof z.infer<typeof client> , string | undefined>}
 */
const _clientEnv = {
  APP_ENV: import.meta.env.MODE,
  API_URL: import.meta.env.VITE_API_URL,
  APP_VERSION: import.meta.env.VITE_APP_VERSION,
  APP_BASE_URL: import.meta.env.BASE_URL,
  APP_HOST_URL: import.meta.env.VITE_HOST_URL,
  API_HOLIDAYS: import.meta.env.VITE_API_HOLIDAYS,
  API_MOCK: import.meta.env.VITE_API_MOCK,
};

const parsed = client.safeParse(_clientEnv);

if (parsed.success === false) {
  console.error(
    '❌ Invalid environment variables:',
    parsed.error.flatten().fieldErrors,

    `\n❌ Missing variables in .env file, Make sure all required variables are defined in the .env file.`,
    `\n💡 Tip: If you recently updated the .env file and the error still persists, try restarting the server with the -cc flag to clear the cache.`,
  );
  throw new Error(
    'Invalid environment variables, Check terminal for more details ',
  );
}

export const Env = parsed.data;
